import * as React from "react";

function SvgLou(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <path
        d="M117.857 189.92c0 9.445 7.143 13.566 16.674 13.566h66.653l2.387 33.028c-26.183 2.366-54.755 2.366-83.326 2.366-30.96 0-45.245-16.524-45.245-42.473V43.04h42.857v146.88zM387.245 143c0 78.275-21.204 102-84.857 102-61.286 0-82.49-23.725-82.49-102s21.204-102 82.49-102c63.653 0 84.857 21.359 84.857 102zm-120.204 0c0 52.183 9.428 66.422 37.714 66.422 28.286 0 37.714-14.28 37.714-66.422 0-52.142-9.428-66.422-37.714-66.422-30.653-2.367-37.714 14.239-37.714 66.422zM575 161.85c0 59.384-21.429 83.15-76.184 83.15-59.53 0-80.959-21.379-80.959-83.15V43.04h42.857v118.81c0 35.638 9.531 47.511 35.715 47.511 26.183 0 35.714-11.873 35.714-47.511V43.04H575v118.81z"
        fill="#FF4081"
      />
    </svg>
  );
}

export default React.forwardRef(SvgLou);
